import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import ApiUtils from '../../utils/ApiUtils';
import SessionStore from '../../stores/SessionStore';
import envConfig from '../../../static/config';
import { MasterCardAlerts } from 'mastercard-alerts-web-ui';
import InternetBankingActions from '../../actions/InternetBankingActions';
import MasterCardAlertStore from '../../stores/MasterCardAlertStore';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';
import { getBrandId } from '../../utils/BrandUtils';
import { BioCatchContext } from '../BioCatchContext';
import { DIGITAL_SERVICING_CONTEXT } from '../../config/BioCatch';

class MasterCardAlertsLanding extends Component {
  constructor(props) {
    super(props);
    this.getConfigInfo = this.getConfigInfo.bind(this);
    this.masterCardAlertBack = this.masterCardAlertBack.bind(this);
    this.masterCardLeavePopup = this.masterCardLeavePopup.bind(this);
  }

  getConfigInfo() {
    const accessToken =
      SessionStore.getURLTokenValue() ||
      SessionStore.getToken()['access_token'];
    return {
      clientContext: ApiUtils.getApiClientContext(),
      accessToken,
      bankId: SessionStore.getSessionBankID(),
      apiBaseUrlPAAS: envConfig.apiBaseUrlPAAS,
      brandId: getBrandId(envConfig.brandId),
      showTransactionAlert: envConfig.isTransactionAlertEnabled,
      showSMEAlert: envConfig.isSMEAlertEnabled,
    };
  }

  getUserInfo() {
    return {
      accountId: MasterCardAlertStore.getManageAlertsAccountID(),
    };
  }

  masterCardAlertBack() {
    InternetBankingActions.navigateToWebTask(
      MasterCardAlertStore.getNavigation()
    );
  }

  masterCardLeavePopup(leavePopup) {
    const {
      masterCardPopupWarningHeader,
      masterCardPopupWarningBody,
      masterCardLeavePageBtn,
      masterCardContinuePageBtn,
    } = this.props.content;

    const modalConfig = {
      displayLeavePopup: leavePopup,
      title: masterCardPopupWarningHeader,
      body: masterCardPopupWarningBody,
      secondaryButtonText: masterCardLeavePageBtn,
      primaryButtonText: masterCardContinuePageBtn,
    };
    SiteHeaderActionCreator.setModalConfig(modalConfig);
  }

  render() {
    return (
      <BioCatchContext context={DIGITAL_SERVICING_CONTEXT}>
        <div id="page" className="bow page mastercard-alerts-landing-page">
          <Helmet title="Alerts" />
          <div className="web-ui-components">
            <MasterCardAlerts
              configValues={this.getConfigInfo()}
              userInfo={this.getUserInfo()}
              masterCardAlertBack={this.masterCardAlertBack}
              masterCardLeavePopup={this.masterCardLeavePopup}
              source="user"
            />
          </div>
        </div>
      </BioCatchContext>
    );
  }
}

MasterCardAlertsLanding.propTypes = {
  content: PropTypes.shape({
    masterCardPopupWarningHeader: PropTypes.string.isRequired,
    masterCardPopupWarningBody: PropTypes.string.isRequired,
    masterCardLeavePageBtn: PropTypes.string.isRequired,
    masterCardContinuePageBtn: PropTypes.string.isRequired,
  }).isRequired,
};
export default RequiresAuthenticatedUser(MasterCardAlertsLanding);
